import { defineStore } from "pinia";
import { CustomerPrice } from "@/models/Customer";

export const useCustomer = defineStore("customer", {
  state: (): CustomerPrice => {
    return { 
      pricesAsB2b: true
    };
  },
  actions: {
    changePriceView(pricesAsB2b: boolean): void {
      this.$patch({ pricesAsB2b });
    }
  }
});